import { render, staticRenderFns } from "./UiOutlineButton.vue?vue&type=template&id=0669bde4&scoped=true"
import script from "./UiOutlineButton.vue?vue&type=script&lang=js"
export * from "./UiOutlineButton.vue?vue&type=script&lang=js"
import style0 from "./UiOutlineButton.vue?vue&type=style&index=0&id=0669bde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0669bde4",
  null
  
)

export default component.exports